class Validation {
  public validateEmail(email: string) {
    return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  }
  public validatePassword(password: string) {
    return password.length >= 6;
  }
}

export const validateUtils = new Validation();
